const ACCOUNT_OWNER_METADATA_KEY = 'accountOwnerMetadata';
const BANK_DOCUMENTS_KEY = 'bankDocuments';
const BANK_KEY = 'bank';
const BANK_TEMPLATES_KEY = 'bankTemplates';
const FI_MARKETPLACE_OFFERS_KEY = 'fiMarketplaceOffers';
const GC_MANAGED_TEMPLATE_METADATAS_KEY = 'gcManagedTemplateMetadatas';
const INVITED_DISPENSARIES_KEY = 'invitedDispensaries';
const LICENSES_KEY = 'licenses';
const MINIFIED_DISPENSARIES_KEY = 'minifiedDispensaries';
const MUOS_KEY = 'muos';
const STAFF_KEY = 'staff';
const TRANSACTION_CODES_KEY = 'transactionCodes';
const USER_KEY = 'user';

export {
  ACCOUNT_OWNER_METADATA_KEY,
  BANK_DOCUMENTS_KEY,
  BANK_KEY,
  BANK_TEMPLATES_KEY,
  FI_MARKETPLACE_OFFERS_KEY,
  GC_MANAGED_TEMPLATE_METADATAS_KEY,
  INVITED_DISPENSARIES_KEY,
  LICENSES_KEY,
  MINIFIED_DISPENSARIES_KEY,
  MUOS_KEY,
  STAFF_KEY,
  TRANSACTION_CODES_KEY,
  USER_KEY
};
